var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { StyledModal, Img } from "./styled";
var PopUpWithImage = /** @class */ (function (_super) {
    __extends(PopUpWithImage, _super);
    function PopUpWithImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        _this.close = function () {
            _this.setState({ isOpen: false });
        };
        _this.open = function () {
            _this.setState({ isOpen: true });
        };
        return _this;
    }
    PopUpWithImage.prototype.render = function () {
        var _a = this.props, backdrop = _a.backdrop, children = _a.children, img = _a.img, maxWidth = _a.maxWidth;
        return (React.createElement(StyledModal, { show: this.state.isOpen, onHide: this.close, keyboard: false, backdrop: backdrop, maxWidth: maxWidth },
            React.createElement("div", null,
                img && React.createElement(Img, { src: img, alt: "pop-up" }),
                children)));
    };
    PopUpWithImage.defaultProps = {
        maxWidth: "450px",
        backdrop: "static"
    };
    return PopUpWithImage;
}(Component));
export default PopUpWithImage;
